"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const stdGrid_1 = require("../stdGrid");
const globals_1 = require("../../models/globals");
const lists_1 = require("../../models/lists");
const boutons_1 = require("../../outils/boutons");
class ListeChrono extends stdGrid_1.default {
    constructor(app, name) {
        super(app, name, {
            moduleName: "chronoDevis",
            datatableName: "chronoDevisDatatable",
            columns: [
                {
                    id: "unid", header: (0, globals_1._)("N°"), width: 80,
                    css: { "text-align": "right" }, sort: "int", hidden: true
                },
                {
                    id: "idTypeDocument", header: (0, globals_1._)("Type"), width: "90", editor: "select",
                    options: lists_1.typeDocumentList, sort: "text"
                }, {
                    id: "numeroDocument", header: (0, globals_1._)("N°"), width: "70",
                    sort: "text"
                }, {
                    id: "dateDocument", header: (0, globals_1._)("Date"), width: "120",
                    sort: "raw", format: webix.i18n.dateFormatStr
                },
                {
                    id: "adresseNom", header: (0, globals_1._)("Nom client"), width: "300",
                    sort: "text",
                    footer: { "text": (0, globals_1._)("Totaux") }
                },
                {
                    id: "totalHT", header: (0, globals_1._)("Total HT"), width: "130",
                    sort: "int",
                    format: function (value) {
                        return webix.i18n.numberFormat(value);
                    }, css: { "text-align": "right" },
                    footer: { content: "summColumn", css: { "text-align": "right" } }
                }, {
                    id: "totalTTC", header: (0, globals_1._)("Total TTC"), width: "130",
                    sort: "int",
                    format: function (value) {
                        return webix.i18n.numberFormat(value);
                    }, css: { "text-align": "right" },
                    footer: { content: "summColumn", css: { "text-align": "right" } }
                }
            ],
            title: (0, globals_1._)("Liste chronologique des devis"),
            boutons: [boutons_1.ouvrirButton],
            resizeColumn: true,
            urlData: globals_1.phpPath + "devis.php?option=listeChrono"
        });
    }
    ouvrir() {
        let idDoc = this.getSelectedIdDoc();
        if (idDoc > 0)
            window.location.href = "#!/pgiLayout/devis?unid=" + idDoc;
    }
    init() {
        this.currentGrid = $$("chronoDevisDatatable");
        // @ts-ignore
        this.currentGrid.config.footer = true;
        let me = this;
        this.currentGrid.attachEvent("onItemDblClick", function () {
            me.ouvrir();
        });
        let menu = this.$$("stdGridMenu");
        menu.attachEvent("onMenuItemClick", function (id, e, node) {
            switch (id) {
                case "ouvrirButton":
                    me.ouvrir();
                    break;
            }
        });
    }
    ready() {
        let me = this;
        let menu = this.$$("stdGridMenu");
        if ((globals_1.lv2.droits).includes("devis.listeChrono")) {
            menu.showMenuItem("ouvrirButton");
        }
    }
}
exports.default = ListeChrono;
